import React, { FunctionComponent } from 'react';
import { ImageModel, ImageRatios, ImageSizes } from '../../../services/content/image/models/ImageModel';
import { VideoFile, VideoModel } from '../../../services/content/video/models/VideoModel';
import { getLeadingMediaOfContent } from '../../../services/content/mainMedia/MainMedia';
import { ResourceTypes } from '../../../services/content/mainMedia/normalizers/MainMediaNormalizer';
import { getMainMediaImageByCropRatio } from '../../../services/content/image/ImageConfiguration';
import styles from '../../../styles/ArticleHeading.module.scss';
import { GoogleAdMobile } from '../../Ads/GoogleAdMobile';
import { AdsConfig } from './models/AdsConfig';
import S365Picture from '../../Image/S365Picture';

type Props = {
    mainMedia: (string | ImageModel | VideoModel | null)[];
    //TODO think of a better way to pass ads, by avoiding prop drilling
    adsConfig: AdsConfig;
    imgAlt?: string;
};

const MainMedia: FunctionComponent<Props> = ({ mainMedia, adsConfig, imgAlt }) => {
    const leadingMedia = getLeadingMediaOfContent(mainMedia);

    if (leadingMedia.resourceType === ResourceTypes.VIDEO && (leadingMedia.data as VideoFile[]).length > 0) {
        let videoModel = mainMedia.find(
            (media) => media && typeof media !== 'string' && media.entityType === ResourceTypes.VIDEO,
        );
        if (videoModel) {
            videoModel = videoModel as VideoModel;
            return (
                <div className={`${styles.negativeMargin}`}>
                    <div className={`${styles.embedResponsive16by9} mb-2 mb-md-3 mb-lg-3`}>
                        <iframe
                            className={`embed-responsive-item`}
                            src={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/embedVideo/${videoModel.id}?autoplay=true`}></iframe>
                    </div>
                </div>
            );
        }
    }

    if (leadingMedia.resourceType === ResourceTypes.EMBED) {
        return (
            <div
                className={`iframeContainer ${styles.negativeMargin}`}
                dangerouslySetInnerHTML={{ __html: leadingMedia.data as string }}></div>
        );
    }

    const image = getMainMediaImageByCropRatio(mainMedia, ImageRatios.RATIO_4X3, ImageSizes.BIG);

    return (
        <div className={`${styles.negativeMargin}`}>
            <GoogleAdMobile ad={adsConfig.mobile.ad} className={`w-100 text-center mb-2`} />
            <S365Picture
                url={image}
                isPriority={true}
                alt={imgAlt}
                className={'normalize-nextjs-image mb-2 mb-md-3 w-100'}
            />
        </div>
    );
};

export default MainMedia;
